<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? '新增' : '删除'" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
            <el-form-item prop="name" label="关联机构">
                <el-select v-model="dataForm.name" placeholder="请选择关联机构">
                    <el-option v-for="item in accountList" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="lxr" label="姓名">
                <el-input v-model="dataForm.lxr" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="mobile" label="电话">
                <el-input v-model="dataForm.mobile" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="userName" label="账号">
                <el-input v-model="dataForm.userName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
                <el-input v-model="dataForm.password" placeholder="请输入"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    import uploadImage from "../../../components/uploadImage";
    export default {
        components: { uploadImage },
        data () {
            return {
                visible: false,
                accountList: [],
                dataForm: {
                    id: null,
                    "name": "",
                    "mobile": "",
                    "lxr": "",
                    "userName": "",
                    "password": "",
                }
            }
        },
        computed: {
            dataRule () {
                return {
                    name: [
                        { required: true, message: '请选择', trigger: 'blur' }
                    ],
                    lxr: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    userName: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            init () {
                this.visible = true
                this.getAccountList()
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            getAccountList() {
                this.$http.get(`/account/selectList`).then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.accountList = res.list
                }).catch(() => {})
            },


            // 获取信息
            getInfo () {
                this.$http.get(`/account/info/${this.dataForm.id}`).then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = res.position
                    this.dataForm.password = ''
                }).catch(() => {})
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http.post(
                        this.dataForm.id ? '/account/update' : '/account/addAccount',
                        this.dataForm,
                    ).then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {})
                })
            }, 1000, { 'leading': true, 'trailing': false })
        }
    }
</script>
